import React from "react";
import FrontendLayout from "../FrontendLayout";
import Hero from "../front-components/Hero";
import ContactDetails from "../front-components/ContactDetails";

export default function Contact() {
  return (
    <FrontendLayout>
      <Hero title="Contact" />
      <ContactDetails/>
    </FrontendLayout>
  );
}
